import { all, call, put, takeEvery } from "redux-saga/effects";
import axios from "axios";
import {
  UPDATE_CORPORATE_STATUS,
} from "../../Action/actionTypes";
import {
  updateCorporateStatusSuccess,
  updateCorporateStatusFailure,
} from "../../Action/corporate/updateCorporateStatusAction";

// Create a custom axios instance for user backend
const userBackendAPI = axios.create({
  baseURL: process.env.REACT_APP_USER_BACKEND_URL,
});

function* updateCorporateStatusRequest(action) {
  try {
    const { data } = yield userBackendAPI.post(`/update-corporate-status`, action?.payload?.payload);

    if (data?.meta?.code === 200) {
      yield put(updateCorporateStatusSuccess(data?.data));
      if (action?.payload?.callback) {
        yield call(action.payload.callback, data);
      }
    } else {
      yield put(updateCorporateStatusFailure());
    }
  } catch (error) {
    if (action?.payload?.callback) {
      yield call(action.payload.callback, {});
    }
    yield put(updateCorporateStatusFailure());
  }
}

export function* watchUpdateCorporateStatusAPI() {
  yield takeEvery(UPDATE_CORPORATE_STATUS, updateCorporateStatusRequest);
}

export default function* rootSaga() {
  yield all([watchUpdateCorporateStatusAPI()]);
}